exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mypage-logo[data-v-a406b58a]{width:133px;position:absolute;top:-5px;left:80px}.navbar[data-v-a406b58a]{height:60px}", ""]);

// exports
